import { render, staticRenderFns } from "./PerformanceReport.vue?vue&type=template&id=51a157ac&"
import script from "./PerformanceReport.vue?vue&type=script&lang=js&"
export * from "./PerformanceReport.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports